export default {
  primary: '#005CE4',
  error: '#CE190D',
  errorAlt: '#bf160a', // TODO: need to discuss with designer to find better solution
  success: '#22AA00',
  successAlt: '#1f8719', // TODO: need to discuss with designer to find better solution
  warning: '#E06F00',
  warningAlt: '#ff620c', // TODO: need to discuss with designer to find better solution
  background: '#E4EBF1',
  backgroundAlt: '#DAE1E9',
  surface: '#FFFFFF',
  surfaceAlt: '#F0F4F8',
  secondary: '#C6D1DB',
  secondaryAlt: '#90A0B3',
  contrastHigh: '#000001',
  contrastLow: '#323a45',
  contrastInvert: '#ffffff',
  overlaySurface: 'rgba(0,0,0,0.8)',
  overlayContrast: '#ffffff',
  code: {
    accent1: '#b4278b',
    accent2: '#22aa01',
    accent3: '#005ce5',
    accent4: '#323a44',
    accent5: '#7c4dff',
    accent6: '#ff5a01',
    accent7: '#01a272',
    accent8: '#38537e',
    accent9: '#ce190e',
  },
  brand: {
    cloudinaryBlue: '#3448c5',
    cloudinaryBlueLight: '#1d3c90',
    cloudinaryBlueDark: '#4c64d7',
    offsetGray: '#f1f2f9',
    darkBlue: '#0c163b',
    accentCoral: '#ff5050',
    accentPeach: '#ffd4c4',
    accentYellow: '#f7bc00',
    accentTurquoise: '#48c4d8',
    accentLightBlue: '#b6d2ff',
  },
};
